export default "__VITE_ASSET__BHfaDeNs__"